import React, { useContext, useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import ContentCommentsTable from "../components/Content/ContentCommentsTable";
import { NavLink } from "react-router-dom";
import { Button } from "antd";

const ContentComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedContentId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Content/${selectedContentId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comment);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedContentId]);
    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>کامنت های {title}</h3>
                <NavLink to="/content">
                    <Button type="primary" danger>بازگشت</Button>
                </NavLink>
            </div>
            <ContentCommentsTable comments={comments} loading={loading} />
        </>
    );
};

export default ContentComments;
